import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLocalizedStrings } from '../../localization/LocalizedStringsProvider';
import { fillHeight } from '../../theme';

// Placeholder. Delivery reporting needs plays coming off the devices first — see docs/ad-sales-plan.md in
// TouchTab.Promotion. The nav item exists now so the section's shape and its permissions are settled.
const Reports = () => {
    const strings = useLocalizedStrings();

    return (
        <Box sx={{ ...fillHeight, overflow: 'auto', p: 2 }}>
            <Stack spacing={2}>
                <Typography variant="h6">{strings.reports}</Typography>
                <Typography variant="body2" color="text.secondary">{strings.promotionReportsComingSoon}</Typography>
            </Stack>
        </Box>
    );
};

export default Reports;
